export default "__VITE_ASSET__BeUTqVrt__"